import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AuditBinderStage } from '@ata-digital/client-tax-system-api-client';
import { AuditBindersListPage } from '@/features/preparer/audit-binders/AuditBindersListPage';
import { auditBinderListQueryOptions } from '@/lib/query/options';
import { QueryErrorBoundary } from '@/components/query/QueryErrorBoundary';

const auditBindersSearchSchema = z
  .object({
    page: z.number().int().positive().optional().catch(undefined),
    rowsPerPage: z.number().int().positive().optional().catch(undefined),
    sortBy: z.string().optional().catch(undefined),
    sortOrder: z.enum(['asc', 'desc']).optional().catch(undefined),
    search: z.string().optional().catch(undefined),
    stages: z.array(z.nativeEnum(AuditBinderStage)).optional().catch(undefined),
    officeId: z.string().optional().catch(undefined),
    dueDateStart: z.string().optional().catch(undefined),
    dueDateEnd: z.string().optional().catch(undefined),
    periodStart: z.string().optional().catch(undefined),
    periodEnd: z.string().optional().catch(undefined),
  })
  .passthrough();

export const Route = createFileRoute('/preparer/audit-binders/')({
  loader: async ({ context: { queryClient } }) => {
    const authState = queryClient.getQueryData(['auth', 'session']) as
      | { token?: string; isAuthenticated?: boolean }
      | undefined;

    if (authState?.token) {
      queryClient
        .prefetchQuery(
          auditBinderListQueryOptions.list(
            {
              page: 1,
              limit: 25,
              sortBy: 'createdAt',
              sortOrder: 'desc',
            },
            authState.token
          )
        )
        .catch(() => {});
    }
  },
  errorComponent: QueryErrorBoundary,
  component: AuditBindersListPage,
  validateSearch: auditBindersSearchSchema,
});
